/* ASELECION – Sprachknopf = Domain-Wechsel (.de DE, .es ES, .com EN, .com/cs CS) über Shopifys hreflang-Links; manueller Farbmodus reist mit */
(function(){
 /* Haartyp-Filter im Magazin übersetzen */
 var I=window.ASEL_I18N;if(I){var A={tg1:['Wellen & Locken · 2A–3C','Waves & curls · 2A–3C','Ondas y rizos · 2A–3C','Vlny a kudrny · 2A–3C'],tg2:['Coils · 3C–4C','Coils · 3C–4C','Coils · 3C–4C','Coily vlasy · 3C–4C']};['en','es','cs'].forEach(function(l,i){Object.keys(A).forEach(function(k){I.K[k]=A[k][0];(I.TR[l]=I.TR[l]||{})[k]=A[k][i+1]})})}
 var D={de:'https://www.aselecion.de/',es:'https://www.aselecion.es/',en:'https://www.aselecion.com/',cs:'https://www.aselecion.com/cs/'};
 function target(l){
  var ls=document.querySelectorAll('link[rel=alternate][hreflang]'),best=null;
  for(var i=0;i<ls.length;i++){var h=(ls[i].getAttribute('hreflang')||'').toLowerCase();if(h===l)return ls[i].href;if(!best&&h.indexOf(l+'-')===0)best=ls[i].href}
  return best||D[l];
 }
 function withTheme(u){var m=window.ASEL_THEME&&window.ASEL_THEME.manual();if(!m)return u;try{var x=new URL(u,location.href);x.searchParams.set('t',m);return x.toString()}catch(e){return u}}
 document.addEventListener('click',function(e){
  var b=e.target&&e.target.closest&&e.target.closest('.asel-ctl .menu button[data-l]');if(!b)return;
  var l=b.dataset.l,cur=(window.ASEL_LOC||{}).cur;
  e.preventDefault();e.stopPropagation();
  var m=b.closest('.lang');m&&m.classList.remove('open');
  if(l===cur)return;
  window.ASEL_LEAVE&&window.ASEL_LEAVE();
  location.href=withTheme(target(l));
 },true);
})();
